// removed by extract-text-webpack-plugin
module.exports = {"container":"UayI","imageWrapper":"_1wmP","image":"_2w8X","content":"_3QOZ"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LandingPage/CaseStudySection/Quote/styles.scss
// module id = 419
// module chunks = 0